import React from "react";

import Text from "src/components/text";

import { getAuthorName } from "src/services/reports.service";
import { formatTimespent } from "src/services/reports.service";

import styles from "./popularViewersListItem.module.scss";
import { Asset } from "src/types/assets";
import { Analytics } from "src/types/reports";

const DefaultAssetIcon = "/images/defaultIcons/default_asset.jpg";


export interface PopularViewerItem {
  asset: Asset;
  analytics: Analytics;
}

export interface PopularViewersListProps {
  item: PopularViewerItem;
  columnCount: number;
}

const PopularViewersListItem: React.FC<PopularViewersListProps> = ({ item, columnCount }) => {
  const { asset, analytics } = item;

  return (
    <div className={styles.row} key={asset.id}>
      <div className={styles.tableDataContainer}>
        <img
          src={asset.icon?.thumbnail || DefaultAssetIcon}
          alt={asset.name}
          className={styles.thumbnail}
        />
        <a
          href={`/assets/${asset.id}?source=reports`}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.linkWrapper}
        >
          <div className={styles.rightData}>
            <div className={styles.tableDataTitle}>
              <Text
                text={asset.name || ""}
                lines={1}
                className={styles.title}
              />
            </div>
            <div className={styles.metaData}>
              {asset.createdDate && (
                <span>
                  Added:{" "}
                  {new Date(asset.createdDate).toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                  })}
                </span>
              )}
              Author:{" "}
              <Text
                text={asset.author ? getAuthorName(asset.author) : ""}
                lines={1}
                className={styles.author}
              />
            </div>
          </div>
        </a>
      </div>

      <div
        className={styles.analyticsContainer}
        style={{
          gridTemplateColumns: `repeat(${columnCount}, minmax(0, 1fr))`,
        }}
      >
        <div className={styles.tableDataViews}>{analytics.views || 0}</div>
        <div className={styles.tableDataTime}>
          {formatTimespent(analytics.avgTimeSpent || 0)}
        </div>
        <div className={styles.tableDataShares}>{analytics.shares || 0}</div>
        <div className={styles.tableDataShares}>{analytics.downloads || 0}</div>
      </div>
    </div>
  );
};

export default PopularViewersListItem;
